import React from 'react';

import Container from 'components/Container';

const Footer = () => {
  return (
    <footer>
      <Container>
        <p>By <a href="https://www.marcosbustamantemateo.com">Marcos Bustamante Mateo</a></p>
      </Container>
    </footer>
  );
};

export default Footer;
